//
import { VCard, VContainer, VFlex, VLayout } from 'vuetify/lib'

//
import RBtnAction from '../ButtonAction'
import RRouterBreadcrumbs from '../RouterBreadcrumb'

//
export default {
    name: 'main-layout',
    components: {
        VCard,
        VContainer,
        VFlex,
        VLayout,
        RBtnAction,
        RRouterBreadcrumbs,
    },
    computed: {
        /**
         *
         */
        hasHistory() {
            return window.history.length > 0
        },
    },
    data() {
        return {
            fluid: true,
        }
    },
    props: {
        /**
         *
         */
        breadcrumbsProps: {
            type: Object,
            default: () => ({}),
        },
    },
}
